import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ptBR from '../i18n/pt-BR';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { ptBR },
    current: 'ptBR',
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#1565C0',
        secondary: '#0097A7',
        accent: '#880E4F',
        error: '#D81B60',
        info: '#1E88E5',
        success: '#00ACC1',
        warning: '#FF8F00',
      },
    },
  },
});
